import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/LG400BiFacial.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="LG 400W Neon2 BiFacial Panel" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/LG400BiFacial.js